export default "__VITE_ASSET__Csh1b8zb__"